<script setup>
import { useGlobalStore } from '@stores/global.js'
import Button from '@components/global/forms/Button.vue'

const global = useGlobalStore()
</script>

<template>
	<header class="fixed top-0 z-40 w-full overflow-hidden bg-gradient-to-b from-crowns-off-black/75 to-transparent transition-colors duration-300 ease-in-out sm:from-crowns-off-black/50">
		<div class="container">
			<div class="flex items-center justify-between pt-5">
				<router-link class="cursor-pointer select-none" :to="{ name: 'index' }">
					<img class="h-12 lg:h-14" src="https://cdn.papercrowns.com/website/images/logos/papercrowns-stacked.svg" alt="Paper Crowns Logo" />
				</router-link>
				<div class="flex gap-2">
					<Button class="hidden sm:block" label="Contact Us" :to="{ name: 'contact' }" />
					<button class="flex items-center gap-3 px-5" @click="global.openModal('Menu')">
						<!-- Menu -->
						<i class="fas fa-bars text-xl" />
					</button>
				</div>
			</div>
		</div>
	</header>
</template>
